export default __webpack_public_path__ + "static/media/petrolead-branco.baafe372.png";